import React, { useRef } from "react";
import { getInputHeight, Size } from "src/utils/formUtils/getInputHeight";
import { CircularProgress } from "@mui/material";

type Props = {
  size?: Size;
  label?: string;
  required?: boolean;
  placeholder?: string;
  onSelect: (file: File) => void;
  selectedFile: any;
  accept: string;
  disabled?: boolean;
  isLoading: boolean;
};

const ATMFileUploader = ({
  size = "small",
  label = "",
  required = false,
  placeholder = "Select Image",
  onSelect,
  selectedFile,
  accept,
  disabled = false,
  isLoading,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const getImageName = (imgUrl: string) => {
    const imageNameList = imgUrl?.split("/");
    const inputrefFile = inputRef.current?.files;

    if (inputrefFile && inputrefFile.length > 0) {
      // Access the first file in the FileList
      const file: File = inputrefFile[0];

      // Get the name of the file
      const fileName = file.name;
      return imageNameList[imageNameList.length - 1] || fileName || "";
    }

    return imageNameList[imageNameList.length - 1] || "";
  };

  return (
    <div>
      {label && (
        <label className="font-medium text-slate-700">
          {label} {required && <span className="text-red-500"> * </span>}
        </label>
      )}
      <button
        type="button"
        onClick={() => {
          inputRef?.current?.click();
        }}
        className={`flex gap-2 items-center px-2 w-full border border-divider rounded bg-white ${getInputHeight(
          size
        )} ${label && "mt-1"} text-slate-400`}
      >
        {selectedFile && (
          <div className="border rounded shadow w-7 h-7 aspect-square">
            {selectedFile && (
              <img
                src={
                  typeof selectedFile === "string"
                    ? selectedFile
                    : URL.createObjectURL(selectedFile)
                }
                alt=""
                className="w-full h-full rounded"
              />
            )}
          </div>
        )}

        {selectedFile ? (
          <div className="py-2 overflow-x-auto font-medium text-slate-900 ">
            {getImageName(selectedFile || "")}
          </div>
        ) : (
          placeholder
        )}
      </button>

      {isLoading && (
        <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
          <CircularProgress />
        </div>
      )}

      {/* Input Type File - Hidden */}
      <input
        type="file"
        ref={inputRef}
        onChange={(e: any) => onSelect(e.target.files[0])}
        className="hidden"
        accept={accept}
        disabled={disabled || isLoading}
      />
    </div>
  );
};

export default ATMFileUploader;
